import { ApiBase } from '../apiBase';
import { ApiHexaBase } from './ApiHexaBase';
import { Wallet, WalletTransaction } from './models/WalletModels';

export class ApiWallet extends ApiHexaBase {
  public static override get baseUrl(): string {
    return `${ApiHexaBase.baseUrl}/wallets`;
  }

  public static async index(
    customer_id: number | string,
    params: {
      page?: number;
      size?: number;
      sort_field?: string;
      sort_direction?: 'asc' | 'desc';
    }
  ) {
    const response = await ApiBase.get(`${this.baseUrl}/${customer_id}`, params);
    return response.data.data as {
      total: number;
      wallets: Wallet[];
    };
  }

  public static async show(
    customer_id: string | number,
    wallet_id: string | number
  ) {
    const response = await ApiBase.get(`${this.baseUrl}/${customer_id}/${wallet_id}`);
    return response.data.data as Wallet;
  }

  public static async update(
    customer_id: string | number,
    wallet_id: string | number,
    data: Partial<Wallet>
  ) {
    const response = await ApiBase.post(`${this.baseUrl}/${customer_id}/${wallet_id}`, data);

    return response.data.data as Wallet;
  }
}

export class ApiWalletTransaction extends ApiHexaBase {
  public static override get baseUrl(): string {
    return `${ApiHexaBase.baseUrl}/transactions`;
  }

  public static async index(
    id: number | string,
    params: {
      page?: number;
      size?: number;
      sort_field?: string;
      sort_direction?: 'asc' | 'desc';
    }
  ) {
    const response = await ApiBase.get(`${this.baseUrl}/${id}`, params);
    return response.data.data as {
      total: number;
      transactions: WalletTransaction[];
    };
  }

  public static async create(
    customer_id: string | number,
    wallet_id: string | number,
    data: Partial<WalletTransaction>
  ): Promise<WalletTransaction> {
    const response = await ApiBase.post(`${this.baseUrl}/${customer_id}/${wallet_id}`, data);

    return response.data.data as WalletTransaction;
  }
}
